import { render, staticRenderFns } from "./asiakirjat.vue?vue&type=template&id=244f5b5d&scoped=true&"
import script from "./asiakirjat.vue?vue&type=script&lang=ts&"
export * from "./asiakirjat.vue?vue&type=script&lang=ts&"
import style0 from "./asiakirjat.vue?vue&type=style&index=0&id=244f5b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f5b5d",
  null
  
)

export default component.exports